export default {
  setSelections(state, val) {
    state.selections = val.selections
  },

  setServiceRequestType(state, val) {
    state.serviceRequestType = val.serviceRequestType
  },

  setType(state, val) {
    state.selectedType = val.body;
  },

  setNextStep(state, val) {
    state.nextStep = val.nextStep
    // state.serviceRequestStatus = val.serviceRequestStatus
  },

  reset(state) {
    state.nextStep = 0
    state.selectedType = {}
  },

  setTypeForm(state, val) {
    state.typeForm = val.form
    // state.serviceRequestStatus = val.form.serviceRequestStatus
  },

  setServiceRequestStatus(state, val) {
    state.serviceRequestStatus = val.serviceRequestStatus
  },

  setGeneralForm(state, val) {
    state.generalForm = val.form;
  }
}



// WEBPACK FOOTER //
// ./src/Osm/ServiceRequest/store/mutations.js